import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { UAParser } from 'ua-parser-js'
import './analytics.txt'
import './healthcheck.txt'

const getDesktopApplication = () => import('./bootstrap')
const getMobileApplication = () => (location.href = '/mobile/')
const parser = new UAParser()
const result = parser.getResult()

if (result.device.type === 'mobile' || result.device.type === 'tablet') {
  const useMobile = confirm('Do you want to use the CALABRIO ONE mobile web app?')
  if (useMobile) {
    getMobileApplication()
  } else {
    getDesktopApplication()
  }
} else {
  getDesktopApplication()
}
